import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=7cc49e2c&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=7cc49e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc49e2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cc49e2c')) {
      api.createRecord('7cc49e2c', component.options)
    } else {
      api.reload('7cc49e2c', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=7cc49e2c&scoped=true&", function () {
      api.rerender('7cc49e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4kspV1OJJZAO0/JS/teamMember.vue"
export default component.exports